import { connect } from 'react-redux';
import { getSubCategory } from 'common/ducks/categories';
import Review from 'marketing/components/review';

const mapStateToProps = ({ categories, marketing }, { item }) => {
  return {
    stats: marketing.reviewStats,
    subCategory: getSubCategory(categories, item.project_sub_category) || {}
  };
}

export default connect(mapStateToProps)(Review);
